import React from 'react';
import { LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
type SectionCtaProps = {
  label: string;
  tone?: 'dark' | 'light';
};
export function SectionCta({
  label,
  tone = 'light'
}: SectionCtaProps) {
  return <div className="mx-auto mt-12 w-full max-w-xl" data-id="element-55" data-mp="3id6xf85hr2aw">
      <CtaButton label={label} data-id="element-56" data-mp="3nc0ax0ks2tb2" />
      <p className={`mt-4 flex items-center justify-center gap-1.5 text-center text-sm font-medium ${tone === 'dark' ? 'text-mist-300' : 'text-mist-600'}`} data-id="element-57" data-mp="3nb8jm1y7rhql">
        <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-58" data-mp="3df5gotvjff2l" />
        One-time payment of $27 · Instant access · 7-Day Guarantee
      </p>
    </div>;
}